import React from 'react';
import { VStack } from '@wegroup/design-system';
import useAdvisoryFlowToolbar from '../../../../../hooks/useAdvisoryFlowToolbar';
import ProgressBarItem from './ProgressBarItem';
import { useTranslation } from 'react-i18next';
import { getTagContentFromStore } from '../../../common/hooks/useTagContent';

const ProgressBar: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation();
  const { itemList, getItemProps } = useAdvisoryFlowToolbar();

  return (
    <VStack
      h="100%"
      overflow="hidden"
      zIndex="2"
      spacing="2"
      alignItems="stretch"
      justifyContent="center"
      data-test-id="ProdFac_ToolbarProgressBar"
    >
      {Object.keys(itemList).map((tag, index) => {
        return (
          <ProgressBarItem
            key={`progress_${tag}`}
            {...getItemProps(tag, index)}
          >
            {getTagContentFromStore(tag) || t(`FLOWS_TOOLBAR_${tag}`)}
          </ProgressBarItem>
        );
      })}
    </VStack>
  );
};

export default ProgressBar;
